import React from 'react'
import PropTypes from 'prop-types'

const AddDomainButton = (props) => (
	<button className="AddDomainButton" onClick={props.click}><span>{props.text}</span></button>
)

AddDomainButton.propTypes = {
	click: PropTypes.func,
	text: PropTypes.string.isRequired
}

export default AddDomainButton


// WEBPACK FOOTER //
// ./src/components/AddDomainControl/AddDomainButton.js